<template>
    <v-container class="pa-2" fluid grid-list-sm >
        <div v-if="needInit">{{initData()}}</div>
        <div v-if="getShowAnswerEvent">{{showAnswer()}}</div>
        <div v-if="getCheckAnswerEvent">{{checkAnswer()}}</div> 
        
        <v-card class="shadow-none" v-if="!needInit">     
            <v-card-text v-if="myContent">
                <div v-html="myContent.content"></div>
                <v-radio-group v-model="selectedIndex" :mandatory="false">
                    <v-layout row wrap align-center v-for="(item, index) in myContent.answer_list" :key="index" >
                        <v-flex xs1>
                            <v-layout justify-center v-if="feedback != null && index == selectedIndex">
                                <v-icon large color="red" v-if="correctAnswer<=0">error</v-icon>
                                <v-icon large color="green" v-if="correctAnswer>0">check_circle</v-icon>
                            </v-layout>
                        </v-flex>
                        <v-flex xs11>
                            <v-radio style="margin-bottom:5px" :label="item.answer" @click.native="reset()" :value="index" :color="getColor()"></v-radio>
                            <p v-if="index == selectedIndex && feedback != null " :style="getStyle()">{{feedback}}</p>
                        </v-flex>
                    </v-layout>
                </v-radio-group>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import {mapGetters} from 'vuex'
import axios from '../../axios-auth.js'
import * as logs from '../../assets/log_process.js'

export default {   
    data() {
        return {
                myContent:  null,
                feedback: null,
                needInit : false,
                styleObject: {
                    color: 'black',
                },
                selectedIndex: 0,
                correctAnswer: -1,
                startTime : null
        }
    },
    computed: 
        mapGetters([
                    'getShowAnswerEvent',
                    'getCheckAnswerEvent',
                    ])
    ,    
    props: { 
        dcontent: Object,
        taskIndex: Number,
        activity_type: String
    },
    methods: {
        initData() {
            this.needInit = false         
            this.$store.commit('setFeedback', null)   
            this.myContent = (this.dcontent.data.content)
            this.feedback = null

            // shuffle            
            var rand = 0
            const _times = 2+Math.floor(Math.random()*3)
            for (let j=0; j<_times; j++) {            
                for(let i = 0; i < this.myContent.answer_list.length; i++) {
                    rand = Math.floor(Math.random() * this.myContent.answer_list.length);
                    [this.myContent.answer_list[i], this.myContent.answer_list[rand]] = [this.myContent.answer_list[rand], this.myContent.answer_list[i]];
                } 
            }                               
        },
        reset() {
            this.feedback = null
            this.correctAnswer = -1
        },
        checkAnswer() {
            this.$store.commit('setCheckAnswerEvent',false) 

            // send info to server
            let answerList = [ this.myContent.answer_list[this.selectedIndex].answer ]  
            const data = {
                task_id : this.dcontent.task_id,
                task_type_id: this.dcontent.task_type_id,
                time_length: Math.floor((new Date() - this.startTime)/1000 + 0.5),
                answer_list : JSON.stringify(answerList), 
                activity_type: this.activity_type
            }

            axios.post('/task-evaluate2', data, this.$store.getters.getAxiosConfig)
                .then((res) => {
                    // eslint-disable-next-line
                    // console.log(res.data)
                    this.useEvaluation(res.data)
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })           
        },
        useEvaluation(myData) {
            this.$store.commit('setWaitingForResult',false) // data was delivered
        //    this.$store.commit('setTaskRating',myData.result.rating/20) // for backdrop
            this.$store.commit('setTransferAnswer',{index: this.taskIndex, rating: myData.result.rating})
            this.$store.commit('setUserPerformance',myData.user)
            this.feedback = myData.result.answers[0].feedback
            this.correctAnswer = myData.result.rating
        },  
        showAnswer() {
            this.$store.commit('setShowAnswerEvent', false)
            
            axios.get('/get-my-answer/'+this.dcontent.task_id, this.$store.getters.getAxiosConfig)
                .then((res) => {
                    this.useAnswer(res.data)
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })                                   
        },        
        useAnswer(myData) {
            // find the text of answer
            for(let i = 0; i < this.myContent.answer_list.length; i++) {
                if (myData.answers[0].answer == this.myContent.answer_list[i].answer) {
                    this.selectedIndex = i
                    break
                }
            }           
            this.$store.commit('setUserPerformance',myData.user)
            this.feedback = myData.answers[0].feedback
        },   
        getStyle() {
            return { color: this.getColor()}
        },
        getColor() {
            if (this.correctAnswer == -1) return "black"
            return this.correctAnswer == 100 ? "green" : "red"
        },       
    },
    mounted() {
        this.needInit = true
        this.startTime = new Date()
        logs.write_to_log('open', 'course', this.dcontent.course_id, 'task', this.dcontent.task_id, 0, this.$store.getters.getAxiosConfig)
    },
    beforeDestroy() {
        logs.write_to_log('close', 'course', this.dcontent.course_id, 'task', this.dcontent.task_id, Math.floor((new Date() - this.startTime)/1000 + 0.5), this.$store.getters.getAxiosConfig)
    }
}
</script>

<style>
</style>